<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Canje de Documentos - Listar</strong>
          </CCardHeader>
          <CCardBody>

          <b-row>
            <b-col sm="12" md="6">
              <b-form-group>
                <label>Proveedor: </label>
                <v-select @input="ListExchangeDocument" placeholder="Todos" class="w-100" :filterable="false" label="name" v-model="provider" @search="SearchProvider" :options="providers"></v-select>
              </b-form-group>
            </b-col>
            
            <b-col sm="6" md="2">
   
            </b-col>
            <b-col sm="6" md="3">
              <b-form-group label=".">
                <b-input-group>
                  <b-form-input v-model="search" class="form-control" ></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="ListExchangeDocument">
                      <b-icon icon="search"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="6" md="1">
              <b-form-group label=".">
                <b-link  v-if="Permission('ExchangeDocumentAdd')" class="btn form-control btn-primary"  :to="{ path: '/canje-de-documentos/nuevo' }" append ><i class="fas fa-file"></i></b-link>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="table-responsive mt-3 height-table">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th width="5%" class="text-center">#</th>
                  <th width="8%" class="text-center">Fecha</th>
                  <th width="40%" class="text-center">Proveedor</th>
                  <th width="23%" class="text-center">Doc. Referencias</th>
                  <th width="5%" class="text-center">Moneda</th>
                  <th width="7%" class="text-center">Total</th>
                  <th width="7%" class="text-center">Estado</th>
                  <th width="7%" class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody v-for="(item, it) in exchange_document" :key="it">
                <tr>
                  <td class="text-center">{{ it + 1 }}</td>
                  <td class="text-center"> {{ item.broadcast_date  }}</td>
                  <td class="text-left"> {{ item.name + ' - '+item.document_number  }}</td>
                  <td class="text-left"> {{ item.references  }}</td>
                  <td class="text-center"> {{ item.coin  }}</td>
                  <td class="text-right"> {{ item.total  }}</td>
                  <td class="text-center">
                    <b-badge v-if="item.state == 1" variant="success">Activo</b-badge>
                    <b-badge v-if="item.state == 0" variant="danger">Anulado</b-badge>
                  </td>
                  <td class="text-center">
                    <b-dropdown bloque size="sm" text="Acciones" right>
                      <b-dropdown-item v-if="Permission('ExchangeDocumentView')" @click="ViewExchangeDocument(item.id_exchange_document)" >Ver</b-dropdown-item >
                      <b-dropdown-item v-if="Permission('ExchangeDocumentDelete')" @click="ConfirmDeleteExchangeDocument(item.id_exchange_document)">Eliminar</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <b-row class="mt-4">
            <b-col md="8">
              <b-pagination v-model="currentPage" v-on:input="ListExchangeDocument" :total-rows="rows" :per-page="perPage" align="center"></b-pagination>
            </b-col>
            <b-col md="4 text-center">
              <p>Pagina Actual: {{ currentPage }}</p>
            </b-col>
          </b-row>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <LoadingComponent :is-visible="isLoading"/>
    <ModalViewExchangeDocument />
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import EventBus from "@/assets/js/EventBus";
import CodeToName from "@/assets/js/CodeToName";
import LoadingComponent from './../pages/Loading'
import ModalViewExchangeDocument from './components/ModalViewExchangeDocument'
export default {
  name: "UsuarioList",
  components:{
    vSelect,
    LoadingComponent,
    ModalViewExchangeDocument,
  },
  data() {
    return {
      isLoading:false,
      module:'ExchangeDocument',

      perPage: 15,
      currentPage: 1,
      rows: 0,
      search: "",
      exchange_document: [],
      providers: [],
      provider:null,

    };
  },
  mounted() {
    this.ListExchangeDocument();

  },
  methods: {
    ListExchangeDocument,
    SearchProvider,
    CodeInvoice,
    EditExchangeDocument,
    ViewExchangeDocument,
    ConfirmDeleteExchangeDocument,
    DeleteExchangeDocument,
    Permission,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_establishment: function () {
      let establishment = window.localStorage.getItem("id_establishment");
      establishment = JSON.parse(je.decrypt(establishment));
      return establishment;
    }
  },
};

function SearchProvider(search, loading) {
  
    let me = this;
    let url = this.url_base + "search-providers/" + search;
    if (search !== "") {
      loading(true);
      axios({
        method: "GET",
        url: url,
      }).then(function (response) {
            me.providers = response.data.result;
            loading(false);
      })
    }
    
}


//listar usuario
function ListExchangeDocument() {
  let search = this.search == "" ? "all" : this.search;
  let id_provider = this.provider == null ? "all": this.provider.id;
  let me = this;
  let url = this.url_base + "exchange-document/list/"+ this.id_establishment +"/" +id_provider+"/"+ search + "?page=" + this.currentPage;
  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.exchange_document = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}




// Editar usuario
function EditExchangeDocument(id_exchange_document) {
  this.$router.push({
    name: "ExchangeDocumentEdit",
    params: { id_exchange_document: je.encrypt(parseInt(id_exchange_document)) },
  });
}

function CodeInvoice(code) {
  return CodeToName.CodeInvoice(code);
}

function ViewExchangeDocument(id_exchange_document) {
  EventBus.$emit('ModalViewExchangeDocumentShow',id_exchange_document);
}

// Confirmar eliminar
function ConfirmDeleteExchangeDocument(id_exchange_document) {
  Swal.fire({
    title: "Esta seguro de eliminar el canje de documentos?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteExchangeDocument(id_exchange_document);
    }
  });
}

// eliminar usuario
function DeleteExchangeDocument(id_exchange_document) {
  let me = this;
  let url = this.url_base + "exchange-document/delete/" + id_exchange_document;
  axios({
    method: "delete",
    url: url,
    headers: { token: this.token, module: this.module, role: 4, },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        for (var i = 0; i < me.exchange_document.length; i++) {
          if (me.exchange_document[i].id_exchange_document == id_exchange_document) {
            me.exchange_document.splice(i, 1);
            break;
          }
        }
        Swal.fire({ icon: 'success', text: 'Se ha eliminado el canje de documentos', timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
